import * as React from 'react'

import { observer } from 'mobx-react'

import FlowSelectorModal from 'modules/contracts/components/FlowSelectorModal'
import PendingApprovalModal from 'modules/contracts/components/PendingApprovalModal'
import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type ContractVersionRequest from 'modules/contracts/store/models/ContractVersionRequest'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  onCloseModal: () => void
  selectedContractVersion: ContractVersion
  employee: Employee
  allContractVersions: ContractVersions
  setOption: React.Dispatch<React.SetStateAction<string>>
  option: string
  showFixOption?: boolean
  contractVersionRequest?: ContractVersionRequest | undefined
}

const ModalSelector = ({
  onCloseModal,
  selectedContractVersion,
  employee,
  allContractVersions,
  setOption,
  option,
  showFixOption,
  contractVersionRequest,
}: Props) => {
  if (contractVersionRequest) {
    return (
      <PendingApprovalModal
        onCloseModal={onCloseModal}
        contractVersionRequest={contractVersionRequest}
        employee={employee}
      />
    )
  }

  return (
    <FlowSelectorModal
      onCloseModal={onCloseModal}
      selectedContractVersion={selectedContractVersion}
      employee={employee}
      allContractVersions={allContractVersions}
      setOption={setOption}
      option={option}
      showFixOption={showFixOption}
    />
  )
}

export default observer(ModalSelector)
